import BasicCard from '../../../components/basics/cards/BasicCard'
import Button from 'react-bootstrap/Button'
import { useState} from "react"
import { UploadAPIService } from '../../../services/apis/UploadAPIService';
import AlertMessage from "../../../components/AlertMessage";

function UploadTask({ refreshSource, setrefreshSource }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [alertObject, setAlertObject] = useState({ variant: '', alertMessage: '' });

    console.log('refreshSource:: ' + refreshSource);

    const handleFileChange = (event) => {
        setAlertObject({ variant: '', alertMessage: '' })
        const file = event.target.files[0];
        if (file) {
            if (!file.name.toLowerCase().endsWith('.xlsx')) {
                setAlertObject({ variant: 'danger', alertMessage: 'Only .xlsx files are allowed!' })
                event.target.value = '';
                return;
            }
            if (file.name.length > 60) {
                setAlertObject({ variant: 'danger', alertMessage: 'Filename should not exceed 60 characters!' });
                event.target.value = '';
                return;
            }
            if (!/^[\w\-\.]+$/.test(file.name)) {
                setAlertObject({ variant: 'danger', alertMessage: 'Filename contains invalid characters! Only letters, numbers, dash (-), and underscore (_) are allowed.' });
                event.target.value = '';
                return;
            }
            const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
            if (file.size > maxSize) {
                setAlertObject({ variant: 'danger', alertMessage: 'File size should not exceed 10 MB!' })
                event.target.value = '';
                return;
            }
        }
        setSelectedFile(file);
    };

    const handleUpload = async () => {
        setAlertObject({ variant: '', alertMessage: '' })
        if (!selectedFile) {
            console.log('No file selected!');
            setAlertObject({ variant: 'danger', alertMessage: 'No file selected!' })
            return;
        }
        setIsProcessing(true);

        try {
            const result = await UploadAPIService.uploadFile(refreshSource, selectedFile);
            if (result.error) {
                console.log('uploadFile-status:: ' + result.message);
                setAlertObject({ variant: 'danger', alertMessage: result.message })
            }
            else {
                console.log('File uploaded successfully!');
                setAlertObject({ variant: 'success', alertMessage: 'Your file has been uploaded successfully. Please wait while we process your data.' })
            }
            var newrefreshSource = refreshSource + ',' + Date.now();
            console.log('setrefreshSource:: ' + newrefreshSource);
            setrefreshSource(newrefreshSource);
            setIsProcessing(false);
            setTimeout(() => {
                setAlertObject({ variant: '', alertMessage: '' });
            }, 10000);
        } catch (error) {
            setIsProcessing(false);
            console.error('Error uploading file:', error);
            setAlertObject({ variant: 'danger', alertMessage: 'File upload failed due to an error! Please try again later or contact support if the issue persists.' })
        }
    };

    return (
        <BasicCard cardConfig={{ cardTitle: 'Run task', cardHeadingElement: 'h5' }}>
            {alertObject.alertMessage ? <AlertMessage alertObject={alertObject} setAlertObject={setAlertObject} /> : ""}
            <div style={{ marginBottom: '10px' }}>
            <label>Select file: </label>
            <input type="file" id="uploadFile" name="uploadFile" onChange={handleFileChange} accept=".xlsx" />
            </div>
            <div style={{ marginTop: '10px' }}>
                <Button variant='primary' onClick={handleUpload} disabled={isProcessing}>
                    {isProcessing ? 'Task is Processing...' : 'Run Task'}</Button>
             </div>
        </BasicCard>
    )
};

export default UploadTask;